// extracted by mini-css-extract-plugin
module.exports = {"container":"image-titled-module--container--aq6u4","image":"image-titled-module--image--20R6g","text":"image-titled-module--text--3bmHB"};